function Home() {
	return (
    <>
    <h1>hello home</h1> 
    <h2>python tutorials</h2>
    <p>i am learning python </p>
    </>
  
  
  
  );


  };
  
  export default Home;